import React from 'react';
import { Field } from '../../ui/Field';
import { TextInput } from '../../ui/TextControl';
import { asDraft } from '../../../types/registration';
import type { QuestionProps } from './types';
export function ContactQuestion({
  data,
  update
}: QuestionProps) {
  const draft = asDraft(data);
  return <div className="flex flex-col gap-5" data-id="element-440" data-mp="3sjo75kmno4tn">
      <Field name="email" label="Email address" hint="Used for sign-in and nothing else." data-id="element-441" data-mp="3skzc3nru7imc">
        <TextInput id="email" name="email" type="email" autoComplete="email" placeholder="you@example.org" value={draft.email} onChange={event => update({
        email: event.target.value
      })} data-id="element-442" data-mp="t3hk95etauv3" />
      </Field>

      <Field name="phone" label="Phone" hint="Optional. Only if email doesn’t reach you." data-id="element-443" data-mp="f36t019lbe9e">
        <TextInput id="phone" name="phone" type="tel" autoComplete="tel" value={draft.phone} onChange={event => update({
        phone: event.target.value
      })} data-id="element-444" data-mp="34ttup4690i9x" />
      </Field>

      <p className="text-small text-ink-muted" data-id="element-445" data-mp="e7l2jeg02b74">
        Neither is ever shown to another member, and neither is used to identify you anywhere on
        the portal.
      </p>
    </div>;
}